import React from "react";

const FozzilIntelligence = () => {
  const heroImageUrl = process.env.PUBLIC_URL + "/fozzil-intelligence-hero.png";
  const image2Url = process.env.PUBLIC_URL + "/fozzil-intelligence-image2.png";
  const image3aUrl =
    process.env.PUBLIC_URL + "/fozzil-intelligence-image3a.png";
  const image3bUrl =
    process.env.PUBLIC_URL + "/fozzil-intelligence-image3b.png";
  const image4Url = process.env.PUBLIC_URL + "/fozzil-intelligence-image4.png";
  const image5Url = process.env.PUBLIC_URL + "/fozzil-intelligence-image5.png";
  const image6Url = process.env.PUBLIC_URL + "/fozzil-intelligence-image6.png";
  const humanCentricImageUrl =
    process.env.PUBLIC_URL + "/fozzil-intelligence-image-human-centric.png";
  const aiMasterImageUrl = process.env.PUBLIC_URL + "/aimaster.png";
  const embeddedVideoUrl = "https://www.youtube.com/embed/UJtOy0661mw";

  return (
    <>
      <div className="bg-black text-white font-secondary overflow-x-hidden">
        {/* Hero Section */}
        <section
          className="w-full h-[80vh] bg-cover bg-center bg-no-repeat flex items-center justify-center"
          style={{ backgroundImage: `url(${heroImageUrl})` }}
        ></section>

        {/* Section 1: Intro Text */}
        <section className="py-12 relative max-w-[1200px] mx-auto px-6 text-center md:px-4 md:py-8">
          <p className="text-[1.75rem] text-[#bfc5c5] leading-9 max-w-[900px] mx-auto mb-8 md:text-[1.25rem] md:mb-6">
            By leveraging cutting-edge AI technologies and sophisticated
            algorithms, advanced virtual assistants aim to provide seamless,
            personalized, and intelligent support across a wide range of tasks
            and interactions, enhancing the overall user experience.
          </p>
        </section>

        {/* Section 2: Main Heading, Intro Paragraph, and Button (Moved) */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <h2 className="font-primary text-[4rem] text-white mb-6 text-center md:text-[2.7rem] sm:text-[2.2rem]">
            FOZZIL INTELLIGENCE
          </h2>
          <p className="text-[1.3rem] text-[#bfc5c5] leading-8 mb-6 text-center">
            It refers to the development of computer systems that can perform
            tasks that typically require human intelligence, such as visual
            perception, speech recognition, decision-making, and language
            translation.
          </p>
          <a
            href="https://fozzilintelligence.com/"
            className="inline-block px-10 py-3 text-[1.3rem] font-semibold font-secondary text-white bg-transparent border-2 border-white rounded-full transition-all duration-200 hover:bg-white hover:text-black mt-6 mb-6"
          >
            Talk to FOZZIL
          </a>

          {/* Blacksite Advanced Untraceable Model Section */}
          
        </section>

        {/* Section 4: Abstract Swirly Image */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <img
            src={image2Url}
            alt="Abstract Swirly Visual"
            className="block max-w-full h-auto my-8 mx-auto rounded-lg md:my-4"
          />
        </section>

        {/* Section 5: Text about virtual assistant */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <p className="text-[1.3rem] text-[#bfc5c5] leading-8 mb-6 text-center">
            A virtual assistant project involves developing an AI-powered
            software program that can provide personalized assistance to users
            in various tasks.
          </p>
        </section>

        {/* Section 4.5: Embedded Video */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <div className="relative overflow-hidden pb-[56.25%] h-0 max-w-[900px] mx-auto my-8">
            <iframe
              className="absolute left-0 top-0 w-full h-full rounded-xl border-none bg-white shadow-[0_2px_12px_rgba(0,0,0,0.08)]"
              src={embeddedVideoUrl}
              title="FOZZIL Intelligence Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-screen"
              allowFullScreen
            ></iframe>
          </div>
        </section>

        {/* Section 6: Text about adaptability */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <p className="text-[1.3rem] text-[#bfc5c5] leading-8 mb-6 text-center">
            Whether in healthcare, smart homes, business automation, or personal
            productivity, FOZZIL Intelligence adapts to diverse environments,
            offering tailored AI-driven solutions.
          </p>
        </section>

        {/* Section 6: Image Gallery with Text */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 md:px-8 md:py-16">
          <div className="flex flex-col md:flex-row gap-8 items-stretch">
            {/* First item */}
            <div className="flex-1 flex flex-col items-center text-center">
              <img
                src={image3aUrl}
                alt="Smart Home AI"
                className="block max-w-full h-auto mb-4 rounded-lg w-[340px] max-w-[540px]"
              />
              <h3 className="font-primary text-[2.1rem] text-white mb-4 md:text-[1.5rem]">
                Adaptive Learning for Personalized Experiences
              </h3>
              <p className="text-[1.2rem] text-[#bfc5c5] leading-8 mb-0 md:text-[1.05rem]">
                FOZZIL Intelligence evolves with each interaction, providing
                smarter responses and more efficient automation, making
                technology work for you.
              </p>
            </div>
            {/* Second item */}
            <div className="flex-1 flex flex-col items-center text-center">
              <img
                src={image3bUrl}
                alt="AI Brain Concept"
                className="block max-w-full h-auto mb-4 rounded-lg w-[340px] max-w-[540px]"
              />
              <h3 className="font-primary text-[2.1rem] text-white mb-4 md:text-[1.5rem]">
                Real-Time Insights and Data Processing
              </h3>
              <p className="text-[1.2rem] text-[#bfc5c5] leading-8 mb-0 md:text-[1.05rem]">
                From complex data analytics to real-time decision-making, FOZZIL
                Intelligence processes vast amounts of information quickly and
                accurately, empowering businesses and individuals alike.
              </p>
            </div>
          </div>
        </section>

        {/* Section 6.5: Display fozzil-intelligence-image4.png as a standalone image */}
        <section className="py-4 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-4">
          <img
            src={image4Url}
            alt="AI Mastery Visual"
            className="block max-w-full h-auto mx-auto rounded-lg"
          />
          <p className="text-[1.3rem] text-[#bfc5c5] leading-8 text-center">
            Designed to be intuitive and user-friendly, FOZZIL Intelligence
            enables seamless communication between users and technology,
            enhancing productivity and comfort.
          </p>
        </section>

        {/* Section 7: Human-Centric Design (Image with Text Overlay) */}
        <section
          className="w-full h-[400px] max-w-[1200px] my-4 bg-cover bg-center flex items-center justify-center text-white rounded-2xl md:h-[320px] md:w-[95%] md:my-2 sm:h-[160px] sm:w-[98%]"
          style={{ backgroundImage: `url(${humanCentricImageUrl})` }}
        ></section>

        {/* Section 8: Another Image Gallery with Text */}
        <section className="py-4 relative max-w-[1200px] mx-auto px-14 md:px-8 md:py-4">
          <div className="flex flex-col md:flex-row gap-8 items-stretch">
            {/* First item */}
            <div className="flex-1 flex flex-col items-center text-center">
              <img
                src={image5Url}
                alt="Voice Capabilities"
                className="block max-w-full h-auto mb-4 rounded-lg w-[340px] max-w-[540px]"
              />
              <h3 className="font-primary text-[2.1rem] text-white mb-4 md:text-[1.5rem]">
                Cutting-Edge Voice and AI Capabilities
              </h3>
              <p className="text-[1.2rem] text-[#bfc5c5] leading-8 text-center mb-0 md:text-[1.05rem]">
                With advanced voice recognition and natural language processing,
                FOZZIL Intelligence powers voice assistants, creating
                hands-free, effortless control over devices and systems.
              </p>
            </div>
            {/* Second item */}
            <div className="flex-1 flex flex-col items-center text-center">
              <img
                src={image6Url}
                alt="Security Concept"
                className="block max-w-full h-auto mb-4 rounded-lg w-[340px] max-w-[540px]"
              />
              <h3 className="font-primary text-[2.1rem] text-white mb-4 md:text-[1.5rem]">
                Security and Efficiency at Its Core
              </h3>
              <p className="text-[1.2rem] text-[#bfc5c5] leading-8 text-center mb-0 md:text-[1.05rem]">
                Equipped with state-of-the-art AI algorithms, FOZZIL
                Intelligence enhances security protocols and optimizes
                workflows, saving time and resources across industries.
              </p>
            </div>
          </div>
        </section>

        {/* Section 9: AI Mastery with Adaptive Technology (Image Background - Needs New Image) */}
        <section
          className="w-[1200px] h-[400px] mx-auto my-8 bg-cover bg-center flex items-center justify-center text-white rounded-2xl md:h-[320px] md:w-[95%] md:my-6 sm:h-[160px] sm:w-[98%]"
          style={{ backgroundImage: `url(${aiMasterImageUrl})` }}
        ></section>

        {/* Section 10: Final Paragraph */}
        <section className="py-24 relative max-w-[1200px] mx-auto px-14 text-center md:px-8 md:py-16">
          <p className="text-[1.35rem] text-[#bfc5c5] leading-9 max-w-[1000px] mx-auto mb-8 md:text-[1.1rem] md:mb-6">
            FOZZIL Intelligence is an advanced AI platform that seamlessly
            integrates cutting-edge technologies to deliver smart, adaptive
            solutions across industries. From enhancing productivity with
            automation to transforming homes with intelligent control, FOZZIL's
            versatile AI evolves with every interaction, providing personalized
            experiences, real-time insights, and efficient automation. Designed
            with user-centricity and innovation at its core, FOZZIL Intelligence
            empowers individuals and businesses to lead in a technology-driven
            world.
          </p>
        </section>
      </div>
    </>
  );
};

export default FozzilIntelligence;
